"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("webfontloader");
var FontCssGenerator_1 = __importDefault(require("./FontCssGenerator"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var SmallText_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Text/SmallText.css");
var CaptionText_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Text/CaptionText.css");
function loadFonts(account, styleWorker, loadFontsIntoBrowser) {
    var serverStoredFontSelections = [commonTypes_1.TextElementType.P, commonTypes_1.TextElementType.H1, commonTypes_1.TextElementType.H2];
    var loadFontsFn = function (fontConfig) {
        var e_1, _a;
        var fonts = fontConfig || account.settings.brand.fonts;
        var selections = [];
        try {
            for (var serverStoredFontSelections_1 = __values(serverStoredFontSelections), serverStoredFontSelections_1_1 = serverStoredFontSelections_1.next(); !serverStoredFontSelections_1_1.done; serverStoredFontSelections_1_1 = serverStoredFontSelections_1.next()) {
                var key = serverStoredFontSelections_1_1.value;
                selections.push({
                    font: fonts[key],
                    tag: key,
                    fallback: key === commonTypes_1.TextElementType.P,
                });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (serverStoredFontSelections_1_1 && !serverStoredFontSelections_1_1.done && (_a = serverStoredFontSelections_1.return)) _a.call(serverStoredFontSelections_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (fonts[commonTypes_1.TextElementType.H2]) {
            selections.push({ tag: "h3", font: fonts[commonTypes_1.TextElementType.H2] });
            selections.push({ tag: "h4", font: fonts[commonTypes_1.TextElementType.H2] });
        }
        if (fonts[commonTypes_1.TextElementType.P]) {
            selections.push({ tag: "p", className: SmallText_css_1.smallTextWidget, font: fonts[commonTypes_1.TextElementType.P] });
            selections.push({ tag: "p", className: CaptionText_css_1.captionTextWidget, font: fonts[commonTypes_1.TextElementType.P] });
        }
        loadFontsIntoBrowser(selections.map(function (s) { return s.font; }));
        var css = (0, FontCssGenerator_1.default)(selections);
        return styleWorker.addToHead(css, "qwilr-fonts");
    };
    return loadFontsFn;
}
exports.default = loadFonts;
